import { auth } from '../auth/firebase.js';

const API_BASE = '/api';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly problem: unknown,
  ) {
    super(`API ${status}`);
  }
}

async function authHeader(): Promise<Record<string, string>> {
  const u = auth.currentUser;
  if (!u) return {};
  const token = await u.getIdToken(/* forceRefresh */ false);
  return { Authorization: `Bearer ${token}` };
}

/**
 * Low-level fetch with `/api` prefix + auth header. Returns the raw
 * Response so callers can distinguish 200 vs 201 (e.g. upsert flows).
 */
export async function apiFetchRaw(path: string, init: RequestInit = {}): Promise<Response> {
  return fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init.headers ?? {}),
      ...(await authHeader()),
    },
  });
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await apiFetchRaw(path, init);

  if (!res.ok) {
    let problem: unknown = null;
    try {
      problem = await res.json();
    } catch {
      // body was not JSON
    }
    throw new ApiError(res.status, problem);
  }

  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
